import React from "react";
import { DialogMessage } from "utils/helpers/DialogMessage";
import { testId } from "tests/testIdStrings";
import { FormattedTypography } from "utils/helpers/FormattedTypography";
import { Stack } from "@mui/material";
import { useTestSettings } from "hooks/useTestSettings";

type Props = {
  open: boolean;
  close: () => void;
};

export const InfoFinalTestDialog: React.FC<Props> = (props) => {
  const { open, close } = props;
  const { finalTest } = useTestSettings();

  const handleClose = () => {
    close();
  };

  return (
    <DialogMessage
      title="test.start.final"
      open={open}
      close={handleClose}
      primaryButtonText="common.close"
      noCancelButton
      dataTestIdString={testId.common.close}
    >
      <Stack spacing={2}>
        <FormattedTypography
          id={"test.final.info.text"}
          values={{
            questions: finalTest.questions,
            duration: finalTest.duration,
            ratio: finalTest.ratio,
            skip: finalTest.skip,
            br: (
              <>
                <br />
                <br />
              </>
            ),
          }}
        />
      </Stack>
    </DialogMessage>
  );
};
